// extracted by mini-css-extract-plugin
export default {"form":"FormComment_form__mqMD5","textarea":"FormComment_textarea__pLcdG","btn":"FormComment_btn__mZff2"};